import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Barra de paginação enxuta (client-side). Renderiza somente se houver
 *  mais de uma página — não pesa quando não é necessário. */
export function Pagination({ page, totalPages, onChange, testId = "pagination" }) {
  if (!totalPages || totalPages <= 1) return null;
  const goPrev = () => onChange(Math.max(1, page - 1));
  const goNext = () => onChange(Math.min(totalPages, page + 1));
  return (
    <div
      className="flex items-center justify-between gap-3 px-4 py-3 border-t border-slate-200 bg-white text-xs text-slate-600"
      data-testid={testId}
    >
      <span>
        Página <strong className="text-slate-800">{page}</strong> de{" "}
        <strong className="text-slate-800">{totalPages}</strong>
      </span>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={goPrev}
          disabled={page <= 1}
          data-testid={`${testId}-prev`}
          className="h-8"
        >
          <ChevronLeft className="w-3.5 h-3.5 mr-1" /> Anterior
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={goNext}
          disabled={page >= totalPages}
          data-testid={`${testId}-next`}
          className="h-8"
        >
          Próxima <ChevronRight className="w-3.5 h-3.5 ml-1" />
        </Button>
      </div>
    </div>
  );
}
